import React from 'react';
import Form from 'components/form';
import SupplierInput from 'components/input/SupplierInput';

export default function SupplierField(props) {
  return <Form.Field {...props} component={SupplierInput} />;
}
